<i18n lang='yml' src='../i18n/ExamView.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          {{`${$t("view_exam")}`}}
        </h4>
      </div>
      <div class="media-body">
        <h5 class="margin-top heading-page">{{ `${$t('exam')} - ${examRecord.name[locale]}`}}</h5>
        <div class="content-block">
          <div class="post-meta">
            <div class="action-bar border-bottom mb-4">
              <h4> {{$t('exam_details')}} </h4>
              <div class="btn-group btn-group-xs ml-auto" role="group" v-if="edit_permission == 'true'">
                <a class="btn btn-sm btn-outline-primary" :href="buildEditPath(examRecord.id)">                                         
                  <font-awesome-icon :icon="['fa', 'pencil-alt']" />
                  {{ $t('edit') }}
                </a>
              </div>
            </div>
            <ul class="exam-details my-4">
              <li>
                <span class="status-bold">
                  {{$t('exam_id')}}
                </span>
                {{examRecord.test_id}} 
              </li>

              <li>
                <span class="status-bold">
                  {{$t('version')}}
                </span>
                {{examRecord.version_name}} 
              </li>

               <li>
                <span class="status-bold">
                  {{$t('inter_provincial')}}
                </span>
                {{examRecord.inter_provincial_exam? $t('yes_val') : $t('no_val')}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('icem_id')}}
                </span>
                {{examRecord.icem_id}}
              </li>

              <!-- Commenting this for now as apparently STO doesn't use it at the moment but leaving it in just in case they want it again -->
              <!-- <li>
                <span class="status-bold">
                  {{$t('scheduled_online')}}
                </span>
                {{examRecord.exam_type.scheduled_online? $t('yes_val') : $t('no_val')}}
              </li> -->

              <li>
                <span class="status-bold">
                  {{$t('english_name')}}
                </span>
                {{examRecord.name['en']}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('french_name')}}
                </span>
                {{examRecord.name['fr']}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('exam_type')}}
                </span>
                {{examRecord.exam_type.name[locale]}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('required_resources')}}
                </span>
                {{examRecord.required_resources}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('time_allowed_for_exam')}}
                </span>
                 {{examRecord.time_allowance }}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('number_of_questions')}}
                </span>
                {{examRecord.number_of_questions}} 
              </li>

              <li>
                <span class="status-bold">
                  {{$t('max_number_of_retries')}}
                </span>
                {{examRecord.exam_type.max_retries}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('wait_between_retries')}}
                </span>
                {{examRecord.exam_type.time_between_retries}} 
              </li>
              
              <li>
                <span class="status-bold">
                  {{$t('pass_marks')}}
                </span>
                {{examRecord.exam_type.pass_mark}}
              </li>

              <li>
                <span class="status-bold">
                  {{$t('current_fee')}}
                </span>
                {{examRecord.exam_type.current_fee}} 
              </li>   

              <li>
                <span class="status-bold"> {{$t('status')}} </span>
                <span v-if="(examRecord.status)">{{ $t(examRecord.status) }} </span>
              </li>

              <li>
                <span class="status-bold">
                  {{$t('status_date')}}
                </span>
                {{formatDate(examRecord.updated_at)}} 
              </li>

              <div class="program_associations_section my-4"> 
                <h5 class="container-item-name">
                  {{ `${$t('program_associations')}`}}
                </h5>

                <ul v-for="(code_name, index) in get_trade_code_and_prog_name(examRecord)" :key="index">
                   <li>{{code_name}}</li> 
                </ul>
               
              </div>
            </ul>
          </div>    
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
  import {formatDate} from '../../../../shared/typescripts/dates.ts'
  export default {                                                                       
    props: ['locale', 'exam', 'base_path', 'edit_permission'],
    data() {
      return {
        loading: true,
        examRecord: {
          name: {},
          exam_type: {name: {}},
          training_programs: {},
        }
      }
      
    },
    mounted () {
      this.loading = false
      this.$i18n.locale = this.locale;
      try {
        this.examRecord = JSON.parse(this.exam)
      }
      catch(err) {
        this.error = true; 
      } 
    },

    methods: { 
      formatDate(dateString) {
        return formatDate(dateString)
      },
      buildEditPath(id) {
        let path =`${this.base_path}/${id}/edit`
        return path;
      },
      get_trade_code_and_prog_name(exam){
        return exam.get_training_program_info
      }
    }
  }
</script>
